/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import * as ReverseImplementation from './reverse-implementation';
import BigHugeCircuit from './big-huge-circuit';
import BaseBigHugeCircuitGroup from '../../implementation-common/base-big-huge-circuit-group';
import { isNearInfinity } from '../../../../utils/common';

export default class SallenKeyBigHugeCircuitGroup extends BaseBigHugeCircuitGroup {
  circuit;
  toleranceInput;
  reverseImplementation = ReverseImplementation;
  @computed('circuit', 'gbwArray', 'nominalValues', 'reverseImplementation') get circuits() {
    var circuit = this.circuit;
    var nominalGbw = circuit.opAmp.gbw;
    var nominalValues = this.nominalValues;
    var reverseImplementation = this.reverseImplementation;
    var c1ToleranceArray = circuit.c1.toleranceArray;
    var c2ToleranceArray = circuit.c2.toleranceArray;
    var r1ToleranceArray = circuit.r1.toleranceArray;
    var r2ToleranceArray = circuit.r2.toleranceArray;
    var r3ToleranceArray = circuit.r3.toleranceArray;
    var r4ToleranceArray = circuit.r4.toleranceArray;
    var r3Value = circuit.r3.value;
    var inverseArray = r3ToleranceArray;
    if (r3Value === 0 || isNearInfinity(r3Value)) {
      inverseArray = r4ToleranceArray;
    }
    //console.time('sklp-bighuge'); //eslint-disable-line no-console
    var r4Start = r3ToleranceArray.length - 1;
    var gbwArray = this.gbwArray;
    var bigHugeCircuitArray = [];
    gbwArray.forEach((gbwValue) => {
      r1ToleranceArray.forEach((r1Value) => {
        r2ToleranceArray.forEach((r2Value) => {
          inverseArray.forEach((inverseValue, index) => {
            var r3Value = r3ToleranceArray[index];
            var r4Value = r4ToleranceArray[r4Start - index];
            c1ToleranceArray.forEach((c1Value) => {
              c2ToleranceArray.forEach((c2Value) => {
                let item = BigHugeCircuit.create({
                  c1: c1Value,
                  c2: c2Value,
                  r1: r1Value,
                  r2: r2Value,
                  r3: r3Value,
                  r4: r4Value,
                  opAmpGbw: gbwValue,
                  nominalValues: nominalValues,
                  nominalGbw: nominalGbw,
                  reverseImplementation: reverseImplementation,
                });
                bigHugeCircuitArray.push(item);
              });
            });
          });
        });
      });
    });
    //console.timeEnd('sklp-bighuge'); //eslint-disable-line no-console

    var result = this.setNormalizers(bigHugeCircuitArray);
    return result;
  }
}
